/* Cocobody — comportements des sections vb-* */
(function () {
  'use strict';
  document.documentElement.classList.add('vb-js');

  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* Apparition douce (le contenu reste visible si l'observateur n'existe pas) */
  function apparitions() {
    var els = document.querySelectorAll('.vb-apparait');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-vu'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-vu'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-vu'); }); }, 2500);
  }

  /* Calculateur de taille : lignes du tableau avec data-min / data-max (kg) */
  function calculateurs() {
    document.querySelectorAll('[data-vb-calc]').forEach(function (bloc) {
      var input = bloc.querySelector('input'), res = bloc.querySelector('.vb-calc__res');
      var table = document.getElementById(bloc.getAttribute('data-vb-calc'));
      if (!input || !res || !table) return;
      var max = Number(bloc.getAttribute('data-max') || 60);
      function maj() {
        var p = parseFloat(String(input.value).replace(',', '.'));
        table.querySelectorAll('tr.is-reco').forEach(function (t) { t.classList.remove('is-reco'); });
        if (!p) { res.textContent = ''; return; }
        if (p > max) { res.innerHTML = bloc.getAttribute('data-trop'); return; }
        var lignes = table.querySelectorAll('tbody tr'), trouve = null;
        lignes.forEach(function (tr) {
          if (trouve) return;
          if (p < Number(tr.dataset.max) || (p === Number(tr.dataset.max) && tr === lignes[lignes.length - 1])) trouve = tr;
        });
        if (p < Number(lignes[0].dataset.min)) trouve = lignes[0];
        if (!trouve) { res.textContent = ''; return; }
        var limite = Number(trouve.dataset.max) - p <= 2 && trouve !== lignes[lignes.length - 1];
        var avant = trouve.dataset.taille;
        if (limite) trouve = lignes[Array.prototype.indexOf.call(lignes, trouve) + 1];
        trouve.classList.add('is-reco');
        var t = trouve.dataset.taille;
        res.innerHTML = 'Taille conseillée : <strong>' + t + '</strong>' + (limite ? ' <span class="vb-muted">(à ' + p + ' kg elle est en haut du ' + avant + ' : le ' + t + ' lui laissera de la marge)</span>' : '');
        bloc.dispatchEvent(new CustomEvent('vb:taille', { bubbles: true, detail: { taille: t } }));
      }
      input.addEventListener('input', maj);
    });
  }

  /* Fenêtres (guide des tailles) */
  function fenetres() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-vb-ouvre]');
      if (o) {
        var d = document.getElementById(o.getAttribute('data-vb-ouvre'));
        if (d && d.showModal) { e.preventDefault(); d.showModal(); }
        return;
      }
      var f = e.target.closest('[data-vb-ferme]');
      if (f) { var dd = f.closest('dialog'); if (dd) dd.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('vb-dialog')) e.target.close();
    });
  }

  /* Vitrine d'accueil : changement de coloris */
  function vitrines() {
    document.querySelectorAll('[data-vb-vitrine]').forEach(function (v) {
      var img = v.querySelector('[data-vb-vitrine-img] img'); if (!img) return;
      v.querySelectorAll('[data-vb-src]').forEach(function (b) {
        b.addEventListener('click', function () {
          v.querySelectorAll('[data-vb-src]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = b.getAttribute('data-vb-src'); img.alt = b.getAttribute('data-vb-alt');
        });
      });
    });
  }

  /* Bloc d'achat */
  function achat(racine) {
    var data;
    try { data = JSON.parse(racine.querySelector('[data-vb-donnees]').textContent); } catch (e) { return; }
    var defPack = data.packs.filter(function (p) { return p.defaut; })[0] || data.packs.filter(function (p) { return p.qte === data.pack_defaut; })[0] || data.packs[0];
    var etat = { pack: defPack.qte, meme: false, pieces: [] };
    var url = new URLSearchParams(location.search);
    var pq = Number(url.get('pack')); if (data.packs.some(function (p) { return p.qte === pq; })) etat.pack = pq;
    var coulDefaut = data.couleurs[0];
    var vu = url.get('variant'); var vInit = vu && data.variantes.filter(function (v) { return String(v.id) === vu; })[0];
    var maxQte = Math.max.apply(null, data.packs.map(function (p) { return p.qte; }));
    for (var i = 0; i < maxQte; i++) etat.pieces.push({ couleur: vInit ? vInit.couleur : (data.couleurs[i % data.couleurs.length] || coulDefaut), taille: vInit ? vInit.taille : null });

    var elFormats = racine.querySelector('[data-vb-formats]'), elPieces = racine.querySelector('[data-vb-pieces]');
    var btn = racine.querySelector('[data-vb-ajout]'), aide = racine.querySelector('[data-vb-aide]');
    var elPrix = racine.querySelector('[data-vb-prix]'), elPrixDet = racine.querySelector('[data-vb-prix-detail]');
    var piste = racine.querySelector('.vb-galerie__piste');
    var sticky = document.querySelector('[data-vb-sticky]');

    function pack() { return data.packs.filter(function (p) { return p.qte === etat.pack; })[0]; }
    function variante(c, t) { return data.variantes.filter(function (v) { return v.couleur === c && v.taille === t; })[0]; }
    function pastille(c) { return (data.teintes[c] || '#ddd'); }

    function rendreFormats() {
      elFormats.innerHTML = '';
      data.packs.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'vb-format'; b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', p.qte === etat.pack ? 'true' : 'false');
        var unit = p.qte > 1 ? '<small>soit ' + euros(Math.round(p.total / p.qte)) + ' l\'une</small>' : '';
        b.innerHTML = (p.badge ? '<span class="vb-format__badge">' + p.badge + '</span>' : '') +
          '<span class="vb-format__radio" aria-hidden="true"></span>' +
          '<span><span class="vb-format__nom">' + p.nom + '</span>' + (p.detail ? '<span class="vb-format__detail">' + p.detail + '</span>' : '') + '</span>' +
          '<span class="vb-format__prix">' + euros(p.total) + unit + '</span>';
        b.addEventListener('click', function () { etat.pack = p.qte; maj(); });
        elFormats.appendChild(b);
      });
    }

    function rendrePieces() {
      elPieces.innerHTML = '';
      var n = etat.pack;
      for (var i = 0; i < n; i++) {
        (function (i) {
          var pc = etat.pieces[i];
          var d = document.createElement('div'); d.className = 'vb-piece'; d.dataset.index = i;
          var titre = n > 1 ? '<div class="vb-piece__titre">Brassière ' + (i + 1) + '</div>' : '';
          var coul = '<div class="vb-piece__ligne"><span class="vb-piece__label">Coloris : <b>' + pc.couleur + '</b></span><div class="vb-pastilles" role="radiogroup" aria-label="Coloris de la brassière ' + (i + 1) + '">' +
            data.couleurs.map(function (c) {
              return '<button type="button" class="vb-pastille" role="radio" aria-checked="' + (c === pc.couleur) + '" aria-label="' + c + '" title="' + c + '" data-c="' + c + '" style="background:' + pastille(c) + '"></button>';
            }).join('') + '</div></div>';
          var montreTaille = !(etat.meme && i > 0);
          var tail = montreTaille ? '<div class="vb-piece__ligne"><span class="vb-piece__label">Taille' + (etat.meme && n > 1 ? ' (pour toutes)' : '') + ' : <b>' + (pc.taille || '—') + '</b></span><div class="vb-tailles-choix" role="radiogroup" aria-label="Taille">' +
            data.tailles.map(function (t) {
              var v = variante(pc.couleur, t), dispo = v && v.dispo;
              return '<button type="button" class="vb-taille" role="radio" aria-checked="' + (t === pc.taille) + '" data-t="' + t + '"' + (dispo ? '' : ' disabled aria-disabled="true" title="Épuisé"') + '>' + t + (dispo ? '' : ' · épuisé') + '</button>';
            }).join('') + '</div></div>' : '';
          d.innerHTML = titre + coul + tail;
          d.querySelectorAll('.vb-pastille').forEach(function (b) {
            b.addEventListener('click', function () { pc.couleur = b.dataset.c; if (i === 0) montrerCouleur(pc.couleur); maj(); });
          });
          d.querySelectorAll('.vb-taille').forEach(function (b) {
            b.addEventListener('click', function () {
              if (b.disabled) return;
              pc.taille = b.dataset.t;
              if (etat.meme) etat.pieces.forEach(function (x) { x.taille = pc.taille; });
              else etat.pieces.forEach(function (x) { if (!x.taille) x.taille = pc.taille; });
              aide.classList.remove('is-erreur'); maj();
            });
          });
          elPieces.appendChild(d);
        })(i);
      }
      var meme = racine.querySelector('[data-vb-meme]');
      if (meme) { meme.hidden = n < 2; meme.querySelector('input').checked = etat.meme; }
    }

    function manque() {
      for (var i = 0; i < etat.pack; i++) {
        var pc = etat.pieces[i];
        if (!pc.taille) return 'Choisissez la taille' + (etat.pack > 1 && !etat.meme ? ' de la brassière ' + (i + 1) : '') + ' (le guide vous aide).';
        var v = variante(pc.couleur, pc.taille);
        if (!v || !v.dispo) return 'Ce coloris est épuisé dans cette taille : choisissez-en un autre.';
      }
      return '';
    }

    function maj() {
      if (etat.meme && etat.pieces[0].taille) etat.pieces.forEach(function (x) { x.taille = etat.pieces[0].taille; });
      rendreFormats(); rendrePieces();
      var p = pack();
      elPrix.textContent = euros(p.total);
      elPrixDet.textContent = p.qte > 1 ? (p.remise > 0 ? p.qte + ' brassières, soit ' + euros(Math.round(p.total / p.qte)) + ' l\'une' : p.qte + ' brassières · ' + (data.prix_note || '')) : data.prix_note || '';
      var m = manque();
      btn.setAttribute('aria-disabled', m ? 'true' : 'false');
      btn.querySelector('[data-vb-ajout-txt]').textContent = m ? (etat.pack > 1 ? 'Choisir les tailles' : 'Choisir la taille') : 'Acheter maintenant · ' + euros(p.total);
      if (!aide.classList.contains('is-erreur')) aide.textContent = m ? '' : data.aide_ok || '';
      if (sticky) {
        sticky.querySelector('[data-vb-sticky-prix]').textContent = euros(p.total) + (p.qte > 1 ? ' · ' + p.qte + ' brassières' : '');
      }
      try { history.replaceState(null, '', majUrl()); } catch (e) {}
    }
    function majUrl() { var u = new URL(location.href); if (etat.pack > 1) u.searchParams.set('pack', etat.pack); else u.searchParams.delete('pack'); return u.toString(); }

    var meme = racine.querySelector('[data-vb-meme] input');
    if (meme) meme.addEventListener('change', function () {
      etat.meme = meme.checked;
      if (etat.meme) etat.pieces.forEach(function (x) { x.taille = etat.pieces[0].taille; });
      maj();
    });

    /* Recommandation venant du calculateur de taille (fenêtre ou section) */
    document.addEventListener('vb:taille', function (e) {
      var t = e.detail && e.detail.taille; if (!t || data.tailles.indexOf(t) < 0) return;
      etat.pieces.forEach(function (x, i) { if (etat.meme || i === 0 || !x.taille) x.taille = t; });
      aide.classList.remove('is-erreur'); maj();
    });

    /* Galerie */
    var vignettes = racine.querySelectorAll('.vb-galerie__vignettes button');
    function allerA(i, doux) {
      var s = piste && piste.children[i]; if (!s) return;
      piste.scrollTo({ left: s.offsetLeft - piste.offsetLeft, behavior: doux ? 'smooth' : 'auto' });
      vignettes.forEach(function (v, j) { v.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    vignettes.forEach(function (v, i) { v.addEventListener('click', function () { allerA(i, true); }); });
    if (piste) piste.addEventListener('scroll', function () {
      var i = Math.round(piste.scrollLeft / piste.clientWidth);
      vignettes.forEach(function (v, j) { v.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }, { passive: true });
    function montrerCouleur(c) {
      if (!piste) return;
      var slides = Array.prototype.slice.call(piste.children);
      var idx = slides.findIndex(function (s) { return s.dataset.couleur === c; });
      if (idx >= 0) allerA(idx, true);
    }

    /* Achat direct : panier vidé, brassières ajoutées (une ligne par variante), puis paiement */
    var envoi = false;
    btn.addEventListener('click', function () {
      var m = manque();
      if (m) {
        aide.textContent = m; aide.classList.add('is-erreur');
        var cible = elPieces.querySelector('.vb-piece'); if (cible) cible.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (envoi) return; envoi = true; btn.setAttribute('aria-busy', 'true');
      var p = pack(), lignes = {};
      for (var i = 0; i < p.qte; i++) {
        var v = variante(etat.pieces[i].couleur, etat.pieces[i].taille);
        lignes[v.id] = (lignes[v.id] || 0) + 1;
      }
      var items = Object.keys(lignes).map(function (id) {
        var props = { '_format': p.nom };
        return { id: Number(id), quantity: lignes[id], properties: props };
      });
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Erreur');
          aide.classList.remove('is-erreur'); aide.textContent = 'Redirection vers le paiement…';
          location.href = '/checkout';
        })
        .catch(function (err) { aide.classList.add('is-erreur'); aide.textContent = 'L\'achat n\'a pas fonctionné (' + err.message + '). Réessayez ou écrivez-nous.'; envoi = false; btn.removeAttribute('aria-busy'); });
    });

    /* Barre fixe mobile : visible quand le bouton d'achat est hors écran */
    if (sticky) {
      var sb = sticky.querySelector('button');
      sb.addEventListener('click', function () {
        var m = manque();
        if (m) { racine.querySelector('[data-vb-choix]').scrollIntoView({ behavior: 'smooth', block: 'start' }); aide.textContent = m; aide.classList.add('is-erreur'); }
        else btn.click();
      });
      var ft = document.querySelector('.vb-footer'), prog = false;
      function majSticky() {
        prog = false;
        var r = btn.getBoundingClientRect(), h = window.innerHeight;
        var horsEcran = r.bottom < 0;
        var basPage = ft && ft.getBoundingClientRect().top < h;
        var v = horsEcran && !basPage;
        sticky.classList.toggle('is-visible', v);
        if (v) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }
      window.addEventListener('scroll', function () { if (!prog) { prog = true; requestAnimationFrame(majSticky); } }, { passive: true });
      window.addEventListener('resize', majSticky);
      majSticky();
    }

    if (vInit) montrerCouleur(vInit.couleur);
    maj();
  }

  function init() {
    apparitions(); calculateurs(); fenetres(); vitrines();
    document.querySelectorAll('[data-vb-achat]').forEach(achat);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
